module.exports = __webpack_public_path__ + "assets/portovelho-ico-pickdate.42577aae.svg";